import { path, omit } from 'ramda';

import { EDealType } from '../../../types/dealType';
import { TGetEstimationWebResponse } from '../types';
import { IEstimationRentData, IEstimationSaleData } from '../../../types/redux/estimation';
import { TGetEstimationSuburbanResponse } from '../../../repositories/price-estimator/v1/get-estimation-suburban';

/**
 * Хелпер форматирует ответ от api get-estimation-sale|rent-web
 * помогает избавиться от лишнего вложенного объекта с именем rent | sale соответственно в каждой api
 * Если ответ пуст (отсутствует объект sale | rent), то в стейт estimation data сохранится null
 * */
export const prepareResponse = (response: TGetEstimationWebResponse, dealType: EDealType) => {
  const prices = path([dealType], response.response) as Record<string, string | number>;
  const rest = omit([dealType], response.response);

  if (!prices) {
    return null;
  }

  return {
    ...rest,
    ...prices,
    dealType,
  } as IEstimationSaleData | IEstimationRentData;
};

export const prepareSuburbanResponse = (response: TGetEstimationSuburbanResponse, dealType: EDealType) => {
  const prices = path([dealType], response.response) as Record<string, string | number>;
  const rest = omit([dealType], response.response);

  if (!prices) {
    return null;
  }

  return {
    ...rest,
    ...prices,
    dealType,
  } as IEstimationSaleData | IEstimationRentData;
};
